var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-wrap df"},_vm._l((['Table','Sphere','Helix','Grid']),function(item,index){return _c('div',{key:index,staticClass:"button",on:{"click":function($event){return _vm.$emit('click',item)}}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }